// extracted by mini-css-extract-plugin
module.exports =  {"container":"_025a50318d--container--_jteP","partial-checkbox-wrapper":"_025a50318d--partial-checkbox-wrapper--AgytH","label":"_025a50318d--label--HGR_0"};